// extracted by mini-css-extract-plugin
export default {"global-container":"CreateUserLinkListView_global-container__CTQzu"};